import {h, Component} from 'preact'
import {TransitionMotion, spring, presets} from 'react-motion'
import {FontPageActions, FontPageStore} from '../actions/actions'
import FontImage from './FontImage'

export default class FontList extends Component {
  constructor (props) {
    super(props)
    this.defaultSampleText = 'Whaddayagonnado?'
    this.state = {
      items: FontPageStore.getFilteredFontList(),
      itemsLoaded: [],
      sampleText: this.defaultSampleText,
      visible: FontPageStore.getListVisibility(),
      isLoading: false
    }
  }

  static defaultProps = {
    visible: false
  }

  updateAllSampleText = (sampleText) => {
    this.setState({
      sampleText: sampleText || this.defaultSampleText
    })
  }

  componentDidMount () {
    FontPageStore.allSampleTextChanged.add(this.updateAllSampleText, this)
    FontPageStore.filteredFontListChanged.add(this.handleFilteredFontListChanged, this)
    FontPageStore.listVisibilityChanged.add(this.handleVisibilityChanged, this)
  }

  componentWillUnmount () {
    FontPageStore.allSampleTextChanged.remove(this.updateAllSampleText, this)
    FontPageStore.filteredFontListChanged.remove(this.handleFilteredFontListChanged, this)
    FontPageStore.listVisibilityChanged.remove(this.handleVisibilityChanged, this)
  }

  handleFilteredFontListChanged (filteredFontList) {
    this.setState({
      items: filteredFontList
    })
  }

  handleVisibilityChanged (visible) {
    this.setState({
      visible: visible
    })
  }

  textInputThrottleID = 0
  handleSampleTextChange = (event) => {
    // capture target - it gets cleared by React before the timeout
    const {target} = event
    clearTimeout(this.textInputThrottleID)
    this.textInputThrottleID = setTimeout(() => {
      FontPageActions.updateAllSampleText(target.value)
      if (window.updateTesterImage) {
        window.updateTesterImage(target.value)
      }
    }, 250)
  }

  handleLoadStart = (url) => {
    const {itemsLoaded} = this.state
    if (itemsLoaded.indexOf(url) < 0) {
      itemsLoaded.push(url)
    }
    // console.log('handleLoadStart', itemsLoaded.length)
    this.setState({ itemsLoaded, isLoading: itemsLoaded.length > 0 })
  }
  handleLoad = (url) => {
    const {itemsLoaded} = this.state
    const position = itemsLoaded.indexOf(url)
    if (position > -1) {
      itemsLoaded.splice(position, 1)
    }
    // console.log('handleLoadComplete', itemsLoaded.length)
    this.setState({ itemsLoaded, isLoading: itemsLoaded.length > 0 })
  }

  render() {
    if (!this.state.visible) {
      return null
    }
    return <div>
      <div className="row preview-input">
        <div className="span-3 spinner">{this.state.isLoading && <img src="/wp-content/themes/terminal-design-5/images/ajax-loader.gif" />}</div>
        <div className="span-9 text-source"><input type="text" onInput={this.handleSampleTextChange}
          onChange={this.handleSampleTextChange} placeholder="Change the text here…" /></div>
      </div>
      <TransitionMotion
        defaultStyles={this.getDefaultMotionValue()}
        styles={this.getEndValue()}
        willLeave={this.willLeave}
        willEnter={this.willEnter} >
          {interpolatedStyles => {
            return <div>
              {interpolatedStyles.map(config => {
                const {style, key} = config
                const model = config.data
                return <FontBox style={style}
                  onLoad={this.handleLoad} onLoadAbort={this.handleLoad} onLoadError={this.handleLoad} onLoadStart={this.handleLoadStart}
                  sampleText={this.state.sampleText}
                  defaultSampleText={this.defaultSampleText}
                  model={model} key={'fb-' + key} />
              })}
            </div>
          }}
      </TransitionMotion>
    </div>
  }

  componentDidUpdate () {
    // :HACK: Hides the extra space above the content when the main menu is closed
    if (this.state.visible && document.documentElement.scrollTop < 86) {
      document.documentElement.scrollTop = 86
    }
  }

  // actual animation-related logic
  getDefaultMotionValue = () => {
    const {items} = this.state
    const configs = items.map ((model, i) => {
      return {
        style: {
          height: spring(0, presets.stiff),
          opacity: spring(1, presets.stiff),
          marginBottom: spring(0, presets.stiff)
        },
        data: model,
        key: this.getConfigKey(model)
      }
    })
    return configs
  }

  getEndValue = () => {
    const {items} = this.state
    const configs = items.map ((model, i) => {
      return {
        style: {
          height: spring(160, presets.stiff),
          opacity: spring(1, presets.stiff),
          marginBottom: spring(10, presets.stiff)
        },
        data: model,
        key: this.getConfigKey(model)
      }
    })
    return configs
  }

  getConfigKey (model) {
    return 'k-' + model.attributes.id
  }

  willEnter = () => {
    return {
      height: 0,
      opacity: 0,
      marginBottom: 0
    }
  }

  willLeave = () => {
    return {
      height: spring(0),
      opacity: spring(0),
      marginBottom: spring(0)
    }
  }
}

class FontBox extends Component {
  state = {
    sampleText: '',
    sampleFont: '',
    pixelRatio: FontPageStore.getPixelRatio()
  }

  componentDidMount () {
    FontPageStore.pixelRatioChanged.add(this.handlePixelRatioChange, this)
  }

  componentWillUnmount () {
    FontPageStore.pixelRatioChanged.remove(this.handlePixelRatioChange)
  }

  handlePixelRatioChange (event) {
    this.setState({
      pixelRatio: FontPageStore.getPixelRatio()
    })
  }

  render () {
    const model = this.props.model
    const acf = model.attributes.acf
    const children = acf.font_family && acf.font_family.acf && acf.font_family.acf.children
    const defaultDisplayCode = acf && acf.default_display_download
    const selectedDisplayCode = this.state.sampleFont || defaultDisplayCode
    const sampleText = this.state.sampleText || this.props.sampleText
    return <div className="row font-box" style={this.props.style}>
      <div className="span-3 left">
        <div className="info">
          <h3 dangerouslySetInnerHTML={{__html: model.attributes.title.rendered}} />
          <span>{children && children.length > 1 ? children.length + ' fonts' : '1 font'}</span>
          <a href={`/fonts/${model.attributes.slug}/`}>View Family</a>
          <div class="collection-link">{acf.collection_link ? <a href={acf.collection_link}>View Collection</a> : ' ' }</div>
        </div>
        <div className="sample-controls">
          <select value={selectedDisplayCode} onChange={this.handleSampleFontChange}>
          {children && children.map(function (child) {
              return <option key={child.ID} value={child.ID}>{child.post_title}</option>
            })
          }</select>
          <input type="text" placeholder="Just change this text here..."
            onInput={this.handleSampleTextChange} onChange={this.handleSampleTextChange} />
        </div>
      </div>
      <div className="span-9 font-image-center"><a href={`/fonts/${model.attributes.slug}/`}>
        {selectedDisplayCode &&
          <FontImage id={selectedDisplayCode} onLoadStart={this.props.onLoadStart}
            onLoad={this.props.onLoad} onLoadAbort={this.props.onLoadAbort} onLoadError={this.props.onLoadError}
            text={sampleText} width="864" height="160" pointSize="72"
            paddingTop="52" paddingLeft="30" cache={this.props.defaultSampleText === sampleText}
            backgroundColor="ffffff" foregroundColor="000000" backgroundOpacity="0"
          />
        }
      </a></div>
    </div>
  }

  _sampleTextInputTID = 0
  handleSampleTextChange = (event) => {
    // capture target - target will be cleared from the event object before the timeout
    var {target} = event

    // use a timeout to avoid hammering the render server
    clearTimeout(this._sampleTextInputTID)
    this._sampleTextInputTID = setTimeout (() => {
      this.setState({
        sampleText: target.value
      })
    }, 250)
  }

  handleSampleFontChange = (event) => {
    var target = event.target
    this.setState({
      sampleFont: target.value
    })
  }
}



// WEBPACK FOOTER //
// ./inc/js/components/FontList.js